import styled from 'styled-components'

import { Box, Flex } from 'ui/bend'
import { VideoPlayerContainer } from 'components_v2/VideoPlayer/_videoPlayerStyles'

export const MusicContainer = styled(Box)`
  /* inherits --video-player-animation-default from _videoPlayerStyles.js */
  --music-player-height-collapsed: 108px;
  --music-player-height-expanded: 115px;
  --music-player-sub-component-height: 24px;

  background: ${(props) => props.theme.colors.base};
  max-height: ${(props) =>
    props.expand
      ? 'var(--music-player-height-expanded)'
      : 'var(--music-player-height-collapsed)'};
  width: ${(props) => (props.expand ? '232px' : '142px')};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06),
    0px 8px 16px rgba(35, 41, 54, 0.08);
  overflow: hidden;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 24px;
  right: 0;
  transition: var(--video-player-animation-default);
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
  z-index: 1; /* Overlay poster */

  ${VideoPlayerContainer} > .vjs-has-started.vjs-user-active & {
    /* Ensure that music is max-height whenever user is active */
    max-height: var(--music-player-height-expanded);

    .music-info-block {
      margin-top: 10px;
    }

    /* show the music toggle switch if the user is active, even if marquee is playing */
    .music-toggle-switch {
      max-height: var(---music-player-sub-component-height);
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }
  }

  /* Show volume only after music is playing and a user is actively engaged */
  ${VideoPlayerContainer} > .vjs-has-started.vjs-user-active &:not(.no_music_playing) .music-volume-slider {
    margin-top: 8px;
    max-height: var(---music-player-sub-component-height);
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  /* Hide the music player after play has started if a user is inactive and the marquee shouldn't be showing -- CONTRACTUAL REQUIREMENT !!*/
  ${VideoPlayerContainer} > .vjs-has-started.vjs-user-inactive.vjs-playing &:not(.show-marquee) {
    transition: all 0.3s ease-out;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    background: transparent;
  }

  .music-toggle-switch,
  .music-volume-slider {
    transition: var(--video-player-animation-default);
  }

  .music-info-block {
    margin-top: 10px;
  }

  .music-volume-slider {
    margin-top: 8px;
  }

  &.show-marquee,
  &.marquee-exiting {
    /* This will collapse the music player when user is inactive and show-marquee and marquee-exit are on the music player. */
    max-height: var(--music-player-height-collapsed);

    .music-info-block {
      margin-top: 0px;
    }

    .music-toggle-switch {
      max-height: 0;
      transform: translateY(-100%);
      opacity: 0;
      visibility: hidden;
    }
  }

  &.show-marquee,
  &.marquee-exiting,
  &.no_music_playing {
    .music-volume-slider {
      margin-top: 0px;
      max-height: 0;
      transform: translateY(100%);
      opacity: 0;
      visibility: hidden;
    }
  }
`

// TODO: rework-animations
export const MusicInfoBlock = styled(Box)`
  transition: 0.3s;
  opacity: ${(props) => (props.state === 'entered' ? 1 : 0)};
`

export const FeedFMCopyright = styled(Flex)`
  align-items: center;

  span {
    color: #636363;
    font-size: 10px;
    padding-right: 5px;
  }
`
